<template>
  <div class="panda-header">
    <header class="main-header">
      <div class="nav_left">
        <span></span>
      </div>
      <div class="nav_center">
          <div class="nav_right">
            <el-badge :value="scheduleNum"  style="margin:0px 0px 0px 0px" >
              <i class="iconfont icon-richeng" @click="calendar" style="font-size:20px;"></i>
            </el-badge>
            <el-badge :value="messageNum" @click="message"   style="margin:0px 30px 0px 30px" >
              <i class="iconfont icon-xiaoxi"  @click="message" style="font-size:22px;"></i>
            </el-badge>
            <el-dropdown trigger="click" >
              <div class="nav_right_in">
                <img src="../assets/images/default_avatar.jpg" id="user_avatar">
                <span id="user_name">{{username}}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span @click="editPassWord">基本信息</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span @click="logout">退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
               </div>
            </el-dropdown>
          </div>
     
      </div>
    </header>
  </div>
</template>

<script>
  import {config} from '../util/config.js'
  import {getMessage} from "../api/statistics.js";
  import crmWs from '@/util/websocket.js'
  export default {
    name: "Header",
    props: ["username", "pcode"],
    data() {
      return {
       scheduleNum:null,
       messageNum:null,
      };
    },
    mounted() {
      this.loadMenuBadges();
      crmWs.connect();
      this._offUnread = crmWs.on('unread', (d) => {
        this.messageNum = (d.total && d.total > 0) ? d.total : null;
      });
    },
    beforeDestroy(){
      if (this._offUnread) this._offUnread();
    },
    methods: {

      // 菜单/日程角标：HTTP 统计接口；实时消息角标由 websocket.js 推送
      loadMenuBadges(){
        this.routeList=JSON.parse(localStorage.getItem("routeListStorage") || "[]");
        getMessage({})
            .then((response) => {
              if (response.code == 200) {

                for(let i in this.routeList){
                  let num=0;
                  if(this.routeList[i].children){
                    let children=this.routeList[i].children;
                    for(let y in children){
                      if(response.data.list[children[y].api]){
                        this.routeList[i].children[y].num=response.data.list[children[y].api].num;
                        num=num+response.data.list[children[y].api].num;
                      }else{
                        this.routeList[i].children[y].num=0;
                      }
                    }
                  }
                  this.routeList[i].num=num;
                }
                localStorage.setItem("routeListStorage",JSON.stringify(this.routeList));

                if(response.data.schedule==0){
                  this.scheduleNum=null;
                }else{
                  this.scheduleNum=response.data.schedule;
                }


              }
            })
            .catch((error) => {
              console.log(error);
        });
      },

      message(){
  
        this.$router.push({
              path: "../../message/info",
              query: {
                engine:"message"
              }
        });
      },

      logout() {
        this.$confirm("此操作将退出登录, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            localStorage.clear();
            config.isLogin = false;
            this.$router.push({
              path: "../login"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消退出"
            });
          });
      },

      editPassWord(){
        this.$router.push({
          path: "/account/editPassword"
        });
      },

      calendar(){
        this.$router.push({
              path: "../../calendar/info",
              query: {
                engine:"calendar"
              }
        });
      }

    },
  };
</script>

<style>
  .panda-header {
    position: fixed;
    min-width: 960px;
    right: 0;
    height: 62px;
    top: 0;
    z-index: 1000;
  } 
  /*  
  .panda-header {
    min-width: 960px;
    right: 0;
    left: 160px;
    top: 0;
    z-index: 1000;
    margin-bottom: 16px;
  }
  */
  .main-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #606266;
    height: 100%;
  }

  .nav_left {
    display: flex;
    align-items: center;
    /* margin-left: 18px; */
  }

  #logo {
    height: 28px;
    margin-right: 10px;
  }

  .nav_left span {
    position: relative;
    display: flex;
    align-items: center;
    /* padding-left: 10px; */
    font-size: 14px;
    color: #24272B;
  }

  /* .nav_left span::before {
    position: absolute;
    content: '';
    left: 0;
    width: 1px;
    height: 14px;
    border-right: 1px solid #DCDFE6;
  } */

  .nav_center {
    display: flex;
    margin-right: 27px;
  }

  .nav_center ul {
    display: flex;
    margin-right: 138px;
  }

  .nav_center li {
    position: relative;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .nav_center li::after {
    position: absolute;
    content: '';
    right: 0;
    width: 1px;
    height: 14px;
    border-right: 1px solid #DCDFE6;
  }

  .nav_center li img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .nav_right {
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color:#fff;
    padding:5px 20px 5px 40px;
    border-radius:50px;
    margin:0px 0px 0px 0px;
  }
  .nav_right_in{
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color:#fff;
  }

  .nav_right #user_avatar {
    border-radius: 50%;
    border: 1px solid white;
    width: 32px;
    height: 32px;
  }

  .nav_right #user_name {
    margin: 0 12px;
  }

  .main-header .navbar {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0.38rem 3.14rem 0 0.46rem;
    height: 100%;
  }

  .main-header .navbar .title {
    flex: 1;
    font-size: 0.2rem;
    font-weight: 600;
    color: #444;
  }

  .main-header .navbar .tool-list {
    display: flex;
    font-size: 14px;
  }

  .main-header .navbar .tool-list .user-info {
    display: flex;
    margin-right: 0.34rem;
  }

  .main-header .navbar .tool-list .logout {
    cursor: pointer;
    color: #5886ff;
  }

  .main-header .navbar .tool-list .user-info .photo {
    vertical-align: top;
    margin-right: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue